import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import type {ReasonOption} from '../../../../../../ui/setup/billing/cancel/types';

import {CheckboxForGroup} from '../../checkbox/checkbox-for-group';

interface Props {
    title: string;
    options: ReasonOption[];
    selectedValues?: string[];
    followUpValues?: Record<string, string>;
    onFollowUpChange?: (id: string, value: string) => void;
}

export function FeedbackFormCheckboxSet(props: Props) {
    return (
        <Stack spacing={8} alignItems='start' isFullWidth={true}>
            <Body isBold={true}>{props.title}</Body>
            {props.options.map((option) => {
                const {followUp} = option;
                const showFollowUp =
                    followUp &&
                    props.selectedValues?.includes(option.value) &&
                    props.onFollowUpChange;

                return (
                    <Stack key={option.value} spacing={8} alignItems='start' isFullWidth={true}>
                        <CheckboxForGroup value={option.value}>
                            <Body>{option.value}</Body>
                        </CheckboxForGroup>
                        {showFollowUp && (
                            <div className='ml-32'>
                                <FormField
                                    innerId={followUp.id}
                                    label={followUp.label}
                                    isRequired={true}
                                    isFullWidth={true}
                                >
                                    <TextField
                                        value={props.followUpValues?.[followUp.id] ?? ''}
                                        onChange={(value) =>
                                            props.onFollowUpChange?.(followUp.id, value)
                                        }
                                        placeholder={followUp.placeholder}
                                    />
                                </FormField>
                            </div>
                        )}
                    </Stack>
                );
            })}
        </Stack>
    );
}
